import React from 'react';
import './App.css'; // Ensure the CSS file is imported
import hero from './hero.jpg'; // Ensure the path to your image is correct

const Main = () => {
  return (
    <div className="main-container fade-in">
      <h1 className="title fade-in">Coming Soon in 2025</h1>
      <div className="content fade-in">
        <div className="image-container fade-in">
          <img src={hero} alt="Hero" className="hero-image fade-in" />
        </div>
        <div className="text-container fade-in">
          <p>HBA Housing is a leading name in the property industry, renowned for our commitment to excellence, innovation, and customer satisfaction. With years of experience and a deep understanding of the ever-evolving real estate market, we pride ourselves on delivering high-quality housing solutions that cater to diverse needs and aspirations.</p>
          
          <p>At HBA Housing, we are passionate about creating communities that enhance the quality of life for residents while contributing positively to the broader property landscape. Our dedicated team of industry professionals works tirelessly to ensure that every project we undertake meets the highest standards of design, sustainability, and functionality.</p>
          
          <p>Whether you are looking for a new home, an investment opportunity, or expert advice on property development, HBA Housing is your trusted partner. We specialize in a wide range of services, including residential developments, commercial properties, and bespoke housing solutions tailored to your unique requirements.</p>
          
          <p>Driven by our core values of integrity, innovation, and excellence, HBA Housing continues to set benchmarks in the property sector. Our customer-centric approach ensures that we build not just houses, but homes that inspire and communities that thrive.</p>
          
          <p>Discover why HBA Housing is the preferred choice for property seekers and investors alike. Experience the difference with a company that puts your needs first and delivers beyond expectations.</p>
        </div>
      </div>
    </div>
  );
};

export default Main;